import React, { PureComponent } from 'react';
import { track } from '@common/utils/ServiceTrack';
import { getDeviceType, DEVICE_TYPE } from '@common/utils/screenUtils';


// 全局样式
import './index.scss';

import Loading from '../../../common/components/Loading'

import { connect } from 'react-redux'

import { withRouter } from 'react-router-dom'

import { hideModal, savePreload } from '../model/actions'


const mapState = (state) => {
	if (!state.app) {
		return {
			loading: true
		};
	}

	return {
		showToast: state.app.showToast,
		showLoading: state.app.showLoading,
		showModalEl: state.app.showModalEl,
		toastMsg: state.app.toastMsg,
		modalMsg: state.app.modalMsg
	}
}

const mapDispatch = {
	hideModal,
	savePreload
}


@withRouter
@connect(mapState, mapDispatch)
class App extends PureComponent {
	constructor(props) {
		super();

    const category = getDeviceType();
    this.deviceType = category;

    
		// 储存服务端预设的数据
		const { preload, savePreload } = props
		preload && savePreload(preload)
	}

	static defaultProps = {
		// 预设数据 可从服务端带过来一些预设数据
		preload: null
	}

  componentDidMount() {
    if (this.deviceType) {
      track.globalConfig({
        service_common_portal_uaType: this.deviceType.uaType,
        service_common_portal_deviceType: this.deviceType.type,
      })
    }

    track.onEvent(
      'service_portal_page_init',
      {
        portal_page_name: 'appinit',
      },
      true
    );

    if (window.matchMedia) {
      const mql = window.matchMedia("(orientation: portrait)");
      this.handleOrientationChange(mql)

      // 现代浏览器使用 addEventListener
      if (mql.addEventListener) {
        mql.addEventListener("change", this.handleOrientationChange);
      }
    }

  }

  handleOrientationChange = (mql) => {
    if (mql) {
      track.globalConfig({
        service_common_portal_orientation: mql.match ? 'portrait' : 'landscape'
      })
    }

  }

	renderToast() {
		const { showToast, toastMsg } = this.props
		return (
			<div className={'toast' + (showToast ? ' show' : '')}>
        <div className="toast_content">
          {toastMsg}
        </div>
      </div>
		)
	}

	renderModal() {
		const { showModalEl, modalMsg, hideModal } = this.props
		return (
			<div className={'modal' + (showModalEl ? ' show' : '')}>
				<div className='mask' onClick={() => {
					hideModal()
				}} />
				<div className='modalInner'>{modalMsg}</div>
			</div>
		)
	}


	render() {
		const { showLoading, loading } = this.props
		if (loading) {
			return null;
		}
		return (
			<div className="app">
				{this.props.children}
				{this.renderToast()}
				{this.renderModal()}
				{showLoading && <Loading delay={true} />}
			</div>
		);
	}
}

export default App;
